module.exports = __webpack_public_path__ + "static/about-520452d066e3d7067a099192b4bf7213.jpg";